import { LogErrors } from './../../LogErrors'

// Evento propio para avisar que la sesión expiró de forma involuntaria (token vencido
// detectado a mitad de uso, no un logout manual). App.js lo escucha para redirigir a
// "/?logout=..." y mostrar el mismo aviso que ya existe en Login ("Tu sesión ha
// finalizado. Ingresa nuevamente"). Se dispara además el evento existente "app:logout"
// para reutilizar la limpieza que ya hacen otros listeners (sockets del Ztudiante, chat).
const SESSION_EXPIRED_EVENT = 'app:session-expired'

const RequestToAPI = async (url, parameters, returnData = true) => {
    try {
        const response = await fetch(url, parameters)
        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            
            const messageId = errorData.messageId
            
            if (messageId) {
                // Sí se recibió un error 102 del server, avisar que se debe reintentar
                if (messageId === 102) {
                    return { success: false, message: '', retry: true }
                }
            } else {
                //return { success: false, message: errorData.message || 'Error de autenticación' }
                return { success: false, message: errorData.message } //errorCode
            }
        }

        if (returnData) {
            const data = await response.json()
            // Retornar la respuesta exitosa
            return { success: true, data: data }
        } else {
            // Retornar la respuesta exitosa
            return { success: true, data: null }
        }
    } catch (error) {
        await LogErrors('RequestToAPI DL DoubleAttempt', error)
        return { success: false, message: '' }
    }
}

/**
 * Notifica a la app que la sesión expiró (messageId 102, "Token inválido o expirado" —
 * confirmado por el backend para cualquier endpoint) y limpia la sesión local.
 * Este es un módulo plano sin acceso al router de React, así que la navegación real la
 * hace un listener en App.js al escuchar SESSION_EXPIRED_EVENT.
 *
 * Protección contra disparos duplicados: si varias peticiones concurrentes fallan casi
 * al mismo tiempo, solo la primera encuentra userData y dispara los eventos; las demás
 * ya no tienen nada que limpiar y no vuelven a disparar nada.
 */
const TriggerSessionExpired = () => {
    try {
        if (!sessionStorage.getItem('userData')) return

        sessionStorage.removeItem('userData')

        // Reutiliza la limpieza que ya hacen otros listeners existentes de "app:logout"
        // (desconectar el socket del Ztudiante, ocultar el chat de soporte, etc.)
        window.dispatchEvent(new Event('app:logout'))

        // Evento propio para que App.js redirija a "/?logout=..." y muestre el aviso.
        window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT))
    } catch (error) {
        // No hay mucho que hacer si esto falla; no debe romper el flujo de la petición.
    }
}

const DoubleAttempt = async (url, parameters, returnData = true) => {
  try {
    const response = await RequestToAPI(url, parameters, returnData)

    if (response.success) {
        //console.log("1er intento")
        //console.log(":")
        return { success: true, data: response.data }
    } else {
        const retry = response.retry

        if (retry) {
            const responseRetry = await RequestToAPI(url, parameters, returnData)

            if (responseRetry.success) {
                //console.log("2do intento")
                //console.log("::")
                return { success: true, data: responseRetry.data }
            } else {
                // Si el segundo intento también regresa messageId 102, no es un fallo
                // transitorio: la sesión realmente expiró. Solo se dispara para
                // peticiones autenticadas (con token), para no afectar al login, que
                // nunca manda Authorization.
                if (responseRetry.retry && parameters?.headers?.Authorization) {
                    TriggerSessionExpired()
                }

                return { success: false, message: responseRetry.message}
            }
        } else {
            return { success: false, message: response.message }
        }
    }
  } catch (error) {
    await LogErrors('DoubleAttempt DL DoubleAttempt', error)
    return { success: false, message: '' }
  }
}

export { DoubleAttempt };